import { useLocation, useRouter } from '@tanstack/react-router';

import type { IStaticBlocksData } from '@dcentralexpedientedigital/fe-shared/types/config.interface';

import { isBlocks } from '../utils/is-blocks';

export const useActiveRouteData = (): IStaticBlocksData | undefined => {
    const location = useLocation();
    const router = useRouter();

    const matchedRoutes = router.matchRoutes(location.pathname, location.pathname.search);
    return matchedRoutes.find(({ staticData }) => isBlocks(staticData))
        ?.staticData as IStaticBlocksData;
};
